import React from "react";
import { faqs } from "../data/faqs";
export function FaqSection() {
  return <section className="section" id="faq" aria-labelledby="faq-heading" data-id="element-34" data-mp="1pk1tikdhvtcr">
      <div className="shell faq-shell" data-id="element-35" data-mp="1pi77f2qhlv73">
        <div className="section-intro" data-id="element-36" data-mp="1bl27lkhd9ska">
          <p className="eyebrow" data-id="element-37" data-mp="1bmd7vablsi6n">QUESTIONS</p>
          <h2 id="faq-heading" data-id="element-38" data-mp="1gjbyhiw26703">
            Before you <span data-id="element-39" data-mp="1gk5aay9vjmp3">get the kit</span>
          </h2>
        </div>
        <div className="fit-note" data-id="element-40" data-mp="248o98n71an4i">
          <strong data-id="element-41" data-mp="249pwdq1br02l">Built for team leaders and internal facilitators working with 3-12 coworkers.</strong>
          <p data-id="element-42" data-mp="28a9ogf71jdhv">
            Practice everyday requests, listening, updates, handoffs and clarifying misunderstandings using complete fictional workplace cases.
          </p>
        </div>
        <div className="faq-list" data-id="element-43" data-mp="1zh6ggmf5zsum">
          {faqs.map(faq => <details key={faq.id} id={faq.id} data-id="element-44" data-mp="2n7ikvnb7b7gg">
              <summary data-id="element-45" data-mp="2n6r0z9qyuy60">
                {faq.question}
                <span aria-hidden="true" data-id="element-46" data-mp="2rz0nsgwsbi42">+</span>
              </summary>
              <p data-id="element-47" data-mp="14va9vs932mzq">{faq.answer}</p>
            </details>)}
        </div>
      </div>
    </section>;
}